module.exports = __webpack_public_path__ + "img/Voronezh-bg.5fc73ae6.jpg";